// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"629d7ac8","239":"37089ce6","557":"66e88986","667":"77dcd96f","762":"f7c61e62"}[chunkId] + ".chunk.js";
};